// Validação do destino de redirecionamento para o WhatsApp.
//
// A página pública /atendimento24h/aguardando recebe o link em ?direto= e no
// JSON do /status, e navega para ele com window.location.href. Esse valor é
// controlado por quem monta a URL, então nunca pode ir para o navegador sem
// passar por aqui: um `javascript:` executaria código no domínio do admin, na
// sessão de quem abrir o link. O único destino legítimo que o servidor gera é
// https://wa.me/<numero>?text=... (ver formatWaLink em atendimento24h.ts).

const HOSTS_PERMITIDOS = new Set(['wa.me', 'api.whatsapp.com'])

/**
 * Devolve o link normalizado se for um destino WhatsApp válido, ou null para
 * qualquer outra coisa (outro esquema, outro host, credenciais na URL, valor
 * malformado). Quem chama trata null como "sem link".
 */
export function waLinkSeguro(valor: string | null | undefined): string | null {
  if (typeof valor !== 'string') return null
  const bruto = valor.trim()
  if (!bruto) return null

  let url: URL
  try {
    // Sem base: valor relativo ou com esquema estranho cai no catch.
    url = new URL(bruto)
  } catch {
    return null
  }

  if (url.protocol !== 'https:') return null
  if (!HOSTS_PERMITIDOS.has(url.hostname)) return null
  if (url.username || url.password) return null
  if (url.port) return null

  return url.toString()
}
